import React from "react";
import { BlockThankYou } from "@/pages/landing/thankYou/ThankYouBlocks";
import { DEFAULT_TY } from "@/pages/landing/thankYou/ThankYouParts";
import { PLATFORM_BRAND } from "@/pages/landing/config";

const SAMPLE_CONTACT = {
  email: "intake@samplefirm.com",
  address: "100 Main Street, Suite 200\nSpringfield", hours: "Mon–Fri 8am–8pm",
};

export function sampleCtx(shared, o = {}) {
  const firm = o.firm || "Sample Law Firm";
  const contact = o.contact && Object.values(o.contact).some(Boolean) ? o.contact : (o.firm ? {} : SAMPLE_CONTACT);
  return {
    firm, logoUrl: o.logoUrl || null, phone: o.phone || "(555) 555-0100", showCall: true, reference: "AB12CD34",
    buyerCode: o.buyerCode || null, contact, videoUrl: o.videoUrl || null,
    timeline: o.timeline?.length ? o.timeline : DEFAULT_TY.timeline,
    headline: `Thank you — ${firm} has your case`,
    message: `A member of ${firm}'s intake team will reach out shortly at the number you provided.`,
    accent: o.accent || "#0a1929", shared, platformName: PLATFORM_BRAND, isTest: false, compact: true,
  };
}

export const DesignPreview = ({ blocks, ctx, note = "Preview with sample details" }) => (
  <div className="max-h-[72vh] overflow-y-auto border-2 border-black" data-testid="ty-design-preview">
    <div className="label-mono sticky top-0 z-10 border-b-2 border-black bg-zinc-50 px-2 py-1">{note}</div>
    <BlockThankYou blocks={blocks} ctx={ctx} />
  </div>
);
